// Agent - ブラウザ、OS、端末判定
// Bowserのインストールが必要
import Bowser from "bowser";

if (Bowser) {
	const parser = Bowser.getParser(window.navigator.userAgent);

	const classArray = [];

	// ブラウザ取得 - body に browser-{*} クラス追加
	if (parser.getBrowser().name) {
		classArray.push(`browser-${parser.getBrowser().name.toLocaleLowerCase()}`)
	}

	// OS取得 - body に os-{*} クラス追加
	if (parser.getOS().name) {
		classArray.push(`os-${parser.getOS().name.toLocaleLowerCase()}`)
	}

	// 端末タイプ取得（'desktop', 'mobile'） - body に platformType-{*} クラス追加
	if (parser.getPlatform().type) {
		classArray.push(`platformType-${parser.getPlatform().type.toLocaleLowerCase()}`)
	}

	// 端末タイプベンダー（'apple', windowsはvendorプロパティなし？） - body に platformVendor-{*} クラス追加
	if (parser.getPlatform().vendor) {
		classArray.push(`platformVendor-${parser.getPlatform().vendor.toLocaleLowerCase()}`)
	}

	document.addEventListener('DOMContentLoaded', function() {
		
		if (classArray.length > 0) {
			document.body.classList.add(...classArray);
		}
	})
} else {
	throw new Error('Jsライブラリ Bowser がインストールされていません');
}